import QuillEmoji from 'piramis-quill-emoji'
import Quill from 'quill'
import 'piramis-quill-emoji/dist/250153f76b8ce2cd82be1e67768297f5.png'
import 'piramis-quill-emoji/dist/quill-emoji.css'

const QuillSetup = {
  init: (): void => {
    // placegolders
    // Quill.register('modules/placeholder', PlaceholderModule(Quill))
    // Quill.register('modules/autocomplete', getAutocompleteModule(Quill))

    // icons
    const icons = Quill.import('ui/icons')

    icons.code = '<svg viewBox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class="ql-stroke" x1="10" x2="8" y1="5" y2="13"></line> </svg>'
    icons.tgpre = '<svg viewBox="0 0 18 18"> <rect class="ql-fill ql-stroke" height="3" width="3" x="4" y="5"></rect> <rect class="ql-fill ql-stroke" height="3" width="3" x="11" y="5"></rect> <path class="ql-even ql-fill ql-stroke" d="M7,8c0,4.031-3,5-3,5"></path> <path class="ql-even ql-fill ql-stroke" d="M14,8c0,4.031-3,5-3,5"></path> </svg>'
    icons.tgspoiler = '<svg viewBox="0 0 18 18"> <g class="ql-fill ql-color-label"> <polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"></polygon> <rect height="1" width="1" x="4" y="4"></rect> <polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"></polygon> <rect height="1" width="1" x="2" y="6"></rect> <rect height="1" width="1" x="3" y="5"></rect> <rect height="1" width="1" x="4" y="7"></rect> <polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"></polygon> <rect height="1" width="1" x="2" y="12"></rect> <rect height="1" width="1" x="2" y="9"></rect> <rect height="1" width="1" x="2" y="15"></rect> <polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"></polygon> <rect height="1" width="1" x="3" y="8"></rect> <path d="M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z"></path> <path d="M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z"></path> <path d="M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z"></path> <rect height="1" width="1" x="12" y="2"></rect> <rect height="1" width="1" x="11" y="3"></rect> <path d="M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z"></path> <rect height="1" width="1" x="2" y="3"></rect> <rect height="1" width="1" x="6" y="2"></rect> <rect height="1" width="1" x="3" y="2"></rect> <rect height="1" width="1" x="5" y="3"></rect> <rect height="1" width="1" x="9" y="2"></rect> <rect height="1" width="1" x="15" y="14"></rect> <polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"></polygon> <rect height="1" width="1" x="13" y="7"></rect> <rect height="1" width="1" x="15" y="5"></rect> <rect height="1" width="1" x="14" y="6"></rect> <rect height="1" width="1" x="15" y="8"></rect> <rect height="1" width="1" x="14" y="9"></rect> <path d="M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z"></path> <rect height="1" width="1" x="14" y="3"></rect> <polygon points="12 6.868 12 6 11.62 6 12 6.868"></polygon> <rect height="1" width="1" x="15" y="2"></rect> <rect height="1" width="1" x="12" y="5"></rect> <rect height="1" width="1" x="13" y="4"></rect> <polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"></polygon> <rect height="1" width="1" x="9" y="14"></rect> <rect height="1" width="1" x="8" y="15"></rect> <path d="M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z"></path> <rect height="1" width="1" x="5" y="15"></rect> <path d="M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z"></path> <rect height="1" width="1" x="11" y="15"></rect> <path d="M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z"></path> <rect height="1" width="1" x="14" y="15"></rect> <rect height="1" width="1" x="15" y="11"></rect> </g> <polyline class="ql-stroke" points="5.5 13 9 5 12.5 13"></polyline> <line class="ql-stroke" x1="11.63" x2="6.38" y1="11" y2="11"></line> </svg>'
    icons.blockquote = '<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16"><g fill="currentColor"><path d="M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9.586a2 2 0 0 1 1.414.586l2 2V2a1 1 0 0 0-1-1zm12-1a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"/><path d="M7.066 4.76A1.665 1.665 0 0 0 4 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112zm4 0A1.665 1.665 0 0 0 8 5.668a1.667 1.667 0 0 0 2.561 1.406c-.131.389-.375.804-.777 1.22a.417.417 0 1 0 .6.58c1.486-1.54 1.293-3.214.682-4.112z"/></g></svg>'
    icons.blockquoteExpandable = '<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 21 21"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M18.51 1.51H2.49m16.02 18H2.49m4.006-5.992l4 4l4.015-4m-8.015-6l4-4l4.015 4M10.51 17.51v-14"/></svg>'

    const Inline = Quill.import('blots/inline')

    class TgPre extends Inline {
      static create(): any {
        return super.create()
      }

      static formats(): boolean {
        return true
      }

      optimize(context: any): void {
        super.optimize(context)
        if (this.domNode.tagName !== this.statics.tagName[0]) {
          this.replaceWith(this.statics.blotName)
        }
      }
    }

    class TgSpoiler extends Inline {
      static create(): any {
        return super.create()
      }

      static formats(): boolean {
        return true
      }

      // eslint-disable-next-line sonarjs/no-identical-functions
      optimize(context: any): void {
        super.optimize(context)
        if (this.domNode.tagName !== this.statics.tagName[0]) {
          this.replaceWith(this.statics.blotName)
        }
      }
    }

    class Blockquote extends Inline {
      static create(): any {
        return super.create()
      }

      static formats(): boolean {
        return true
      }

      // eslint-disable-next-line sonarjs/no-identical-functions
      optimize(context: any): void {
        super.optimize(context)
        if (this.domNode.tagName !== this.statics.tagName[0]) {
          this.replaceWith(this.statics.blotName)
        }
      }
    }

    class BlockquoteExpandable extends Inline {
      static create(): any {
        return super.create()
      }

      static formats(): boolean {
        return true
      }

      // eslint-disable-next-line sonarjs/no-identical-functions
      optimize(context: any): void {
        super.optimize(context)
        if (this.domNode.tagName !== this.statics.tagName[0]) {
          this.replaceWith(this.statics.blotName)
        }
      }
    }

    // Fix for link custom protocols support
    const PROTOCOL_WHITELIST = new Set([ 'http', 'https', 'tg', 'tel', 'mail', 'maps' ])
    const Link = Quill.import('formats/link')
    Link.sanitize = function (url: string): string {
      // prefix default protocol.
      let protocol = url.slice(0, url.indexOf(':'))
      if (!(url.indexOf('%') === 0 && url.indexOf('%', 1) > 0) && !PROTOCOL_WHITELIST.has(protocol)) {
        url = `https://${ url }`
      }
      // Link._sanitize function
      const anchor = document.createElement('a')
      anchor.href = url
      protocol = anchor.href.slice(0, anchor.href.indexOf(':'))
      return PROTOCOL_WHITELIST.has(protocol) ? url : this.SANITIZED_URL
    }
    Quill.register(Link, true)

    TgPre.blotName = 'tgpre'
    TgPre.tagName = [ 'pre' ]
    Quill.register('formats/tgpre', TgPre)

    TgSpoiler.blotName = 'tgspoiler'
    TgSpoiler.tagName = [ 'tg-spoiler' ]
    TgSpoiler.className = 'bg-gray-500'

    Blockquote.blotName = 'blockquote'
    Blockquote.tagName = [ 'blockquote' ]
    Blockquote.className = 'blockquote-format'

    BlockquoteExpandable.blotName = 'blockquoteExpandable'
    BlockquoteExpandable.tagName = [ 'blockquote' ]
    BlockquoteExpandable.className = 'blockquote-format_expandable'

    Quill.register('formats/tgspoiler', TgSpoiler)
    Quill.register('formats/blockquote', Blockquote)
    Quill.register('formats/blockquoteExpandable', BlockquoteExpandable)

    const ScriptTag = Quill.import('formats/underline')
    ScriptTag.tagName = 'u'
    Quill.register(ScriptTag, true)

    const emojiToolbarModulePath = 'module/emoji-toolbar'
    Quill.register(emojiToolbarModulePath, QuillEmoji.ToolbarEmoji)
    Quill.register(emojiToolbarModulePath, QuillEmoji.ShortNameEmoji)
    Quill.register(emojiToolbarModulePath, QuillEmoji.TextAreaEmoji)
  },
}
export default QuillSetup
